import type { CallerAuthorisedContact } from '../../types/agreementAccess.types';
import { relationshipLabel } from '../../utils/authorisedContactLabels';
import { SECTION_DIVIDER_CLASSES, SECTION_HEADING_CLASSES } from './sectionStyles';

interface Props {
    contacts: CallerAuthorisedContact[];
}

export const AUTHORISED_CONTACT_LIMIT = 25;

const NOTE = "If one of these people is contacting you, they confirm the customer's details above, not their own.";
const LIMIT_NOTE = 'More authorised contacts may exist. They are listed on the Agreement once it is open.';

export function AuthorisedContactsList({ contacts }: Props) {
    if (contacts.length === 0) return null;

    return (
        <section className={`space-y-2 ${SECTION_DIVIDER_CLASSES}`}>
            <h3 className={SECTION_HEADING_CLASSES}>Authorised contacts</h3>
            <p className="text-sm text-mp-muted">{NOTE}</p>
            <ul className="space-y-1 text-sm">
                {contacts.map((contact, index) => (
                    <li key={`${index}-${contact.name}`}>
                        <span className="font-medium">{contact.name}</span>
                        {contact.relationship && (
                            <span className="text-mp-muted">
                                {' '}
                                ({relationshipLabel(contact.relationship)})
                            </span>
                        )}
                    </li>
                ))}
            </ul>
            {contacts.length >= AUTHORISED_CONTACT_LIMIT && (
                <p className="text-xs text-mp-muted">{LIMIT_NOTE}</p>
            )}
        </section>
    );
}
